/** @jsxImportSource @emotion/react */
import 'twin.macro';

type SummaryMetricProps = {
  title: string;
  value: string;
};

export const SummaryMetric = ({ title, value }: SummaryMetricProps) => {
  return (
    <div tw="flex flex-col items-center justify-center p-8 bg-white rounded-lg shadow-md flex-1 md-down:(p-6) sm-down:(p-4)">
      <div tw="text-center md-down:text-sm">{title}</div>
      <div tw="font-bold text-2xl md-down:text-xl sm-down:text-lg">{value}</div>
    </div>
  );
};
